import { put, select, takeEvery } from 'redux-saga/effects';

import type { AuthUser } from '@/modules/auth/schemas/oauth';
import { authSessionStart } from '@/modules/auth/services/actions';
import { authUser } from '@/modules/auth/services/selectors/auth';

import { assignedToMeViewFilter } from '../../utilities/assignedToMeViewFilter';
import { setViewFilter, setViewFilterSeeded } from '../actions';
import { selectViewFilterSeeded } from '../selectors/secrets';

// Applies the per-session default view for admins: "assigned to me" instead of "all".
// It can't run unconditionally — authSessionStart fires on every app boot (reload, new
// tab), not just fresh logins. And viewFilter === null can't signal "fresh session",
// because an explicit "All" choice is stored as null too. Hence the viewFilterSeeded
// flag: persisted, so reloads don't re-seed and stomp the user's choice; reset with the
// rest of the slice on authSessionEnd, so every new session gets the default again.
export function* seedViewFilter() {
    const user: AuthUser | null = yield select(authUser);
    const seeded: boolean = yield select(selectViewFilterSeeded);

    if (!user?.isAdmin || seeded) {
        return;
    }

    yield put(setViewFilterSeeded());
    yield put(setViewFilter(assignedToMeViewFilter(user)));
}

export default function* () {
    yield takeEvery(authSessionStart, seedViewFilter);
}
